import React from 'react';
import { translate } from 'react-jhipster';
import { ICommodity } from 'app/shared/model/commodity.model';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

interface CommodityPriceCardProps {
  commodities: ICommodity[];
  lang?: string;
  sx?: object;
}

const cardSx = {
  width: '100%',
  borderRadius: 3,
  border: '1px solid',
  borderColor: 'divider',
  boxShadow: '0 1px 4px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.06)',
};

export const CommodityPriceCard = ({ commodities, lang = 'en', sx }: CommodityPriceCardProps) => {
  const cellSx = { borderBottom: 'none', textAlign: lang === 'en' ? 'left' : 'right' } as const;

  return (
    <Card elevation={0} sx={{ ...cardSx, ...sx }}>
      <CardContent sx={{ p: { xs: 2, sm: 2.5 }, '&:last-child': { pb: { xs: 2, sm: 2.5 } } }}>
        <Typography variant="subtitle1" fontWeight={600} mb={2} letterSpacing="-0.01em" component="div">
          {translate('home.topInfo.commodityPrice')}
        </Typography>
        <TableContainer sx={{ maxHeight: 200 }}>
          <Table size="small">
            <TableBody>
              {commodities?.map(commodity => (
                <TableRow key={commodity.id}>
                  <TableCell sx={cellSx}>{commodity.name}</TableCell>
                  <TableCell align="right" sx={{ ...cellSx, whiteSpace: 'nowrap' }}>
                    {commodity.price?.toLocaleString()}
                    {commodity.currency && (
                      <Typography component="span" variant="body2" color="text.secondary" fontWeight={600} sx={{ ml: 0.75 }}>
                        ({commodity.currency})
                      </Typography>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default CommodityPriceCard;
